import { Page } from 'layouts/Page';
import { FC } from 'react';
import { VatCorrections } from 'components/VatCorrections';

export const VatCorrectionsPage: FC = () => {
	return (
		<Page title="VAT Corrections – EAS Dashboard">
			<VatCorrections />
		</Page>
	);
};
